<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-select size="medium" clearable v-model="searchForm.menu"  @change="getTableList">
        <el-option label="菜单/功能" value=""></el-option>
        <el-option label="菜单" value="1"></el-option>
        <el-option label="功能" value="0"></el-option>
      </el-select>
      <!-- <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button> -->
    </div>
    <div class="searchRight">
      <el-select size="medium" clearable v-model="searchForm.roleId" @change="getTableList" placeholder="请选择角色">
        <el-option
          v-for="item in roleList"
          :key="item.roleId"
          :label="item.roleName"
          :value="item.roleId">
        </el-option>
      </el-select>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="allotFunc">分配</el-button>
      <el-button size="medium" type="warning" icon="el-icon-plus" @click="addFunc" v-if="developer">增加一级模块</el-button>
      <el-button size="medium" type="danger" @click="deleteMoreType" v-if="developer"><i class="el-icon-delete" style="margin-right:3px;"></i>批量删除</el-button>
    </div>
   </div>
   <el-table
      style="margin-bottom:50px"
      :data="tableData"
      row-key="id"
      border
      :class="'mytables'"
      ref="multipleTable"
      default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55">
        <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checks" @change="toselect(scope.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="模块名">
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column prop="" label="菜单/功能">
        <template slot-scope="scope">
          <div @click="changeStatusFunc" style="display:inline-block;">
            <el-switch 
            v-model="scope.row.menu"
            :disabled="!developer"
            @change="changeStatus(scope.row)"
            class="demo"
            active-color="#00A854"
            :active-text="scope.row.menu==1?'菜单':'功能'"
            active-value="1"
            inactive-color="#999"
            :inactive-text="scope.row.menu==1?'菜单':'功能'"
            inactive-value="0"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作"  v-if="developer">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editFunc(scope.row)">
            <i class="el-icon-edit" style="margin-right:3px;"></i>修改
          </el-button>
          <el-button size="mini" type="warning" @click="addSubFunc(scope.row)">
            <i class="el-icon-edit" style="margin-right:3px;"></i>新增子模块
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="deleteType(scope.row)"
          >
            <i class="el-icon-delete" style="margin-right:3px;"></i>删除
          </el-button>
        </template>
      </el-table-column>
   </el-table>
   <el-dialog
    @close="beforeClose"
    :title="ruleForm.id?'添加模块':'修改模块'"
    :visible.sync="dialogVisible"
    width="430px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="模块名称" prop="name" :rules="rules.blurRule">
            <el-input placeholder="请输入模块名称" v-model="ruleForm.name" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="模块标识" prop="code" :rules="rules.blurRule">
            <el-input placeholder="请输入英文标识" v-model="ruleForm.code" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="模块路径">
            <el-input placeholder="请输入路由名称" v-model="ruleForm.uri" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="是否是菜单" prop="menu">
            <el-radio-group v-model="ruleForm.menu">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRowClick: false,
	  	isAllSelectClick: false,
      totalNum:0,
      searchForm:{
        roleId: '',
        menu: '1'
      },
      tableData: [],
      dialogVisible:false,
      ruleForm:{
          id:'',
          name:'',
          code:'',
          isDel:'0',
          uri:'',
          parent:'',
          menu:'1'
      },
      rules: {
        blurRule: [
          { required: true, message: "请输入", trigger: "blur" }
        ]
      },
      roleList:[],
      multipleSelection:[],
      developer:false,//开发者修改路由
    };
  },
  watch:{
      multipleSelection(val){
        
      }
  },
  created() {
    this.getTableList()
    this.getRoleList()
    if(this.$selfFunc.etUrlCode('developer')=='11111111') {
      this.developer=true
    }
  },
  methods: {
    // 更改批量选中
    toselect(row) {//每一行单个单个点击
      this.isRowClick = true
      if (row.checks) this.initSelect(row.children,'row')
      else {
        this.clearSelect(row.children)
      }
      this.initDD()
      this.isRowClick = false
      // this.$refs.multipleTable.toggleRowSelection(row);
    },
    initDD() {
      this.isAllSelectClick = true
      this.$refs.multipleTable.clearSelection();
      this.togg(this.tableData)
      this.isAllSelectClick = false
    },
    togg(val) {
      if (!val) return
      val.forEach(item => {
        if (item.checks) this.$refs.multipleTable.toggleRowSelection(item);
        if (item.children && item.children.length > 0) this.togg(item.children)
      })
    },
    clearSelect(val) {
      if (!val) return
      val.forEach(item => {
        this.$set(item, 'checks', false)
        if (item.children && item.children.length > 0) this.clearSelect(item.children)
      })
    },
    initSelect(val,type) {
      if (!val) return
      val.forEach(item => {
        if(type=='init') {
          item.isDri=='y'?this.$set(item, 'checks', true):this.$set(item, 'checks', false)
          if(item.checks){
            this.multipleSelection.push(item)
          }
        } else if(type=='row'){
          this.$set(val, 'checks', true)
        }else{
          this.$set(item, 'checks', true)
        }
        if (item.children && item.children.length > 0) this.initSelect(item.children,type)
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.isAllSelectClick) return
      this.clearSelect(this.tableData)
      this.initSelect(val)
      this.initDD()
      if (!this.isRowClick && !this.tableData[0].checks) {
        this.clearBatch()
        this.clearSelect(this.tableData)
        return
      }
    },
    clearBatch() {
      this.$refs.multipleTable.clearSelection();
    },
    allotFunc(row){
        if(this.searchForm.roleId===''){
          this.$message.error('请选择需要分配的角色');
          return
        }
        this.$confirm(`确定要分配吗吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let ids = this.multipleSelection.map(x=>x.id).join(',')
          let res = await this.$http.roleDisPermission({roleId:this.searchForm.roleId,ids:ids});
          if (res) {
            this.$message.success('操作成功！');
          }
        }).catch(() => {
                
        });
    },
    changeStatusFunc(){
      if(!this.developer) {
        this.$message.warning('该功能仅供开发者使用！');
        return
      }
    },
    // 修改状态
    async changeStatus(row){
        let res = await this.$http.updatePermissionMenu({id:row.id,menu:row.menu==1?'1':'0'});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
    },
    async getTableList(){
       let res = await this.$http.getAllPermission({...this.searchForm});
        if (res) {
        this.tableData=JSON.parse(res.data)
        this.multipleSelection=[]
        this.initSelect(this.tableData,'init')
        }
    },
    async getRoleList(){
      let res = await this.$http.roleList();
      if (res) {
      this.roleList=res.list
      }
    },
    beforeClose(){
      this.ruleForm.name='';
      this.ruleForm.code='';
      this.ruleForm.uri='';
      this.ruleForm.parent='';
      this.ruleForm.id='';
      this.ruleForm.isDel='0'
      this.ruleForm.menu='1';
    },
    addFunc(){
      this.dialogVisible=true
    },
    addSubFunc(row){
      this.ruleForm.parent=row.id;
      this.dialogVisible=true
    },
    editFunc(row){
      this.ruleForm.name=row.name;
      this.ruleForm.code=row.code;
      this.ruleForm.uri=row.url;
      this.ruleForm.parent=row.parent;
      this.ruleForm.id=row.id;
      this.ruleForm.menu=row.menu;
      this.dialogVisible=true;
    },
    deleteMoreType(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择需要删除的模块！');
        return
      }
      this.$confirm(`确定要批量删除吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let ids = this.multipleSelection.map(x=>x.id).join(',')
          let res = await this.$http.batchDelPermission({ids:ids});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    deleteType(row){
        this.$confirm(`确定要删除 ${row.name} 模块吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          console.log(row)
          let res = await this.$http.delPermission({ids:row.id});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    async submitForm() {
      this.$refs['ruleForm'].validate(async (valid) => {
          if (valid) {
            let res = await this.$http.addPermission({...this.ruleForm});
            if (res) {
              this.dialogVisible=false
              this.$message.success('操作成功！');
              this.getTableList()
              this.$refs['ruleForm'].resetFields();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
      });
    },
  }
};
</script>

<style scoped>


</style>
